import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

export function QuestionStep({ question, value, onChange }) {
  return (
    <div className="space-y-8" data-testid={`question-step-${question.code}`}>
      <div>
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">{question.label}</span>
        <h2 className="font-heading text-xl sm:text-2xl tracking-tight mt-3 text-foreground leading-snug">
          {question.question}
        </h2>
      </div>

      {question.type === "number" ? (
        <div className="flex items-center gap-2 max-w-xs">
          <span className="font-mono text-muted-foreground text-lg whitespace-nowrap shrink-0">USD $</span>
          <Input
            type="number"
            min="0"
            inputMode="decimal"
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="0"
            className="h-12 text-base font-mono"
            data-testid={`number-input-${question.code}`}
          />
        </div>
      ) : question.type === "select" ? (
        <Select value={value || ""} onValueChange={onChange}>
          <SelectTrigger className="w-full h-12 text-base" data-testid={`select-${question.code}`}>
            <SelectValue placeholder="Select an option" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {question.options.map((opt) => (
              <SelectItem key={opt} value={opt} data-testid={`select-option-${question.code}-${opt}`}>
                {opt}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <div className="border-t border-border">
          {question.options.map((opt) => (
            <button
              type="button"
              key={opt}
              onClick={() => onChange(opt)}
              data-testid={`radio-option-${question.code}-${opt}`}
              className={cn(
                "w-full flex items-center gap-3 text-left py-4 border-b border-border transition-colors duration-150 hover:bg-secondary/40",
                value === opt ? "text-foreground" : "text-muted-foreground"
              )}
            >
              <span
                className={cn("h-2 w-2 shrink-0 border border-foreground", value === opt && "bg-foreground")}
                aria-hidden="true"
              />
              <span className="text-sm sm:text-base">{opt}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
